import { Link } from "react-router-dom";
import { resolveImg } from "@/lib/api";

export default function ProductCard({ p }) {
    return (
        <Link
            to={`/collections/${p.category_slug}/${p.slug}`}
            data-testid={`product-card-${p.id}`}
            className="group"
        >
            <div className="hover-zoom aspect-[3/4] bg-melilux-surface relative">
                {/* card_image is the admin-cropped 3:4 thumbnail; images[0] is the untouched original. */}
                {(p.card_image || p.images?.[0]) && (
                    <img src={resolveImg(p.card_image || p.images[0], 800)} alt={p.name} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                )}
                {p.sale_percentage && (
                    <div className="absolute top-0 left-0 right-0 flex items-center justify-between px-4 py-2 bg-melilux-gold">
                        <span className="text-[0.6rem] uppercase tracking-[0.35em] text-melilux-bg/70">Sale</span>
                        <span className="text-[0.6rem] uppercase tracking-[0.35em] text-melilux-bg font-medium">−{p.sale_percentage}%</span>
                    </div>
                )}
            </div>
            <div className="mt-4">
                <div className="overline">{p.category_name || p.room}</div>
                <div className="mt-2 flex items-baseline justify-between gap-3">
                    <h3 className="font-serif text-xl md:text-2xl text-melilux-cream group-hover:text-melilux-gold transition-colors capitalize">
                        {p.name}
                    </h3>
                    {p.price && (
                        <div className="shrink-0 flex items-baseline gap-2">
                            {p.sale_price && (
                                <span className="text-sm text-melilux-cream/30 line-through tracking-wide">
                                    {p.currency === "MDL" ? `${p.price} MDL` : `€${p.price}`}
                                </span>
                            )}
                            <span className={`text-sm uppercase tracking-[0.15em] ${p.sale_price ? "text-melilux-gold" : "text-melilux-cream/55"}`}>
                                {p.currency === "MDL"
                                    ? `${p.sale_price || p.price} MDL`
                                    : `€${p.sale_price || p.price}`}
                            </span>
                        </div>
                    )}
                </div>
                {p.status !== "Available" && (
                    <p className="mt-1 text-[0.62rem] uppercase tracking-[0.25em] text-melilux-cream/35">{p.status}</p>
                )}
            </div>
        </Link>
    );
}
